import React from 'react';
import Icon from '../home/Icon';
import { useOffline } from '../context/OfflineContext';
import ReconnectButton from '../shell/ReconnectButton';
import './EventOfflineStatus.css';

// Status-Banner zum Spieltag (ersetzt auf /event den globalen OfflineBanner):
//  - online + Spieltagleiter: "lokal gespeichert" + Stand
//  - Offline-Modus mit Daten: Stand + Hinweis auf spätere Übertragung + "Erneut verbinden"
//  - Offline-Modus OHNE lokale Kopie: Erklärung, warum die Liste leer ist + "Erneut verbinden"
function formatStand(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
    + ', ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}

function EventOfflineStatus({ isLeader = false, noCache = false, fetchedAt = null }) {
  const { isOffline, reconnectFailed } = useOffline();
  const stand = formatStand(fetchedAt);
  const lead = reconnectFailed ? 'Weiterhin keine Verbindung' : 'Offline';

  if (isOffline && noCache) {
    return (
      <div className="eventOfflineStatus offline" role="status" aria-live="polite">
        <Icon className="eventOfflineStatusIcon" icon="cloud_off" />
        <span className="eventOfflineStatusText">
          <strong>{lead} · keine lokale Kopie</strong> – offline verfügbar ist nur der nächste Spieltag,
          für eingetragene Spieltagleiter und wenn er vorher einmal online geöffnet wurde.
        </span>
        <ReconnectButton />
      </div>
    );
  }

  if (isOffline) {
    return (
      <div className="eventOfflineStatus offline" role="status" aria-live="polite">
        <Icon className="eventOfflineStatusIcon" icon="cloud_off" />
        <span className="eventOfflineStatusText">
          <strong>{lead}</strong> · {isLeader ? 'lokale Kopie' : 'zuletzt geladener Stand'}
          {stand ? ` · Stand ${stand}` : ''} · Änderungen werden übertragen, sobald du wieder verbunden bist
        </span>
        <ReconnectButton />
      </div>
    );
  }

  if (!isLeader) return null;

  return (
    <div className="eventOfflineStatus saved" role="status">
      <Icon className="eventOfflineStatusIcon" icon="cloud_done" />
      <span className="eventOfflineStatusText">
        Spieltag lokal gespeichert{stand ? ` · Stand ${stand}` : ''} · offline bearbeitbar
      </span>
    </div>
  );
}

export default EventOfflineStatus;
